(ns motorsaif.web.forms.car
  (:require
   [reagent.core :as r]
   [motorsaif.i18n :as i18n :refer [tr]]
   [taoensso.encore :as encore]
   [reagent.ratom :as ra]
   [goog.string :as gstr :refer [format]]
   [motorsaif.web.lib.form :as form]
   [motorsaif.utils :as utils]
   [clojure.string :as str]
   [re-frame.core :as rf :refer [dispatch subscribe]]))

;; A car is saved before things are added to it.
;; If it's a repair shop, we can save customer name too.
;;
;;

;; Let's have a grid of car makes and a search box to filter them.
;; Download Sayartii's make/model list

;; Two stages: Select make, select model

(defn- completed-car? [car]
  (let [{id :db/id :car/keys [make model year]} car]
    (and id make model year)))

(defn- highlight [s search-text]
  (let [match (re-find (re-pattern (str "(?i)" (utils/regex-escape-str search-text))) s)
        [pre post] (str/split s (re-pattern (str "(?i)" (utils/regex-escape-str search-text))) 2)]
    (cond (and match pre post)
          [:span
           [:span.pre pre]
           [:span.stronger match]
           [:span.post post]]
          :else
          [:span s])))

;; UNUSED
(defn- filter-make-text [query makes]
  (let [text query]
    (filter
     (fn [v]
       (re-find
        (re-pattern (str "(?i)^" (utils/regex-escape-str query)))
        v))
     makes)))

(defn make-model-selector [{:keys [default-vals input set-val get-val select] :as form}]
  (let [make-models @(subscribe [:makes-models])
        makes (sort-by :title (mapv #(hash-map
                                      :img (format "/static/img/car-makes/%s.png" (str/replace % " " "_"))
                                      :title % :value %) (keys make-models)))
        years (mapv #(hash-map :title % :value %) (reverse (range 1940 2025)))
        get-models (fn [make]
                     (sort-by :title (mapv #(hash-map :title % :value %)
                                           (get make-models make))))
        {default-year :car/year
         default-make :car/make
         default-model :car/model} default-vals
        *make (ra/reaction (or
                            (get-val [:car :car/make])
                            default-make))]
    (fn []
      ;; (println "RERENDERED")
      [:div.make-model-selector
       [select
        years
        {:label (tr :forms.car.year.title)
         :placeholder (tr :forms.car.year.placeholder)
         :class "year"
         :default-value default-year}
        [:car :car/year encore/as-int]]
       [select
        makes
        {:label (tr :forms.car.make.title)
         :default-value default-make
         :placeholder (tr :forms.car.make.placeholder)
         :after-change
         (fn [_]
           (set-val [:car :db/id] "new")
           (set-val [:car :car/model] nil))}
        [:car :car/make]]
       ^{:key @*make}
       [select
        (get-models @*make)
        {:label (tr :forms.car.model.title)
         :disabled (nil? @*make)
         :default-value default-model
         :placeholder (tr :forms.car.model.placeholder)}
        [:car :car/model]]])))

(defn text-fields [{:keys [default-vals input get-val] :as form}]
  (fn []
    [:div.text-fields
     [input {:label (tr :forms.car.vin.title)
             :placeholder (tr :forms.car.vin.placeholder)
             :helper (tr :forms.car.vin.description)
             :default-value (:car/vin default-vals)}
      [:car :car/vin]]]))

(defn new-car [{:keys [input set-val get-val] :as form}]
  (let [car (get-val [:car])
        {:car/keys [year make model]} car
        car-selected? (completed-car? car)]
    [:div.form-section
     [:div.newly-chosen-car
      (if car-selected?
        [:span.chosen
         (str/join " - " (remove nil? [year make model]))]
        [:span
         "Select year, make, and model"])]
     [make-model-selector form]
     [text-fields form]]))

(defn edit-car [{:keys [default-vals input set-val get-val] :as form}]
  (let [car (get-val [:car])
        {:car/keys [year make model vin]} car
        car-selected? (completed-car? car)
        form (assoc form :default-vals default-vals)]
    [:div.form-section
     [:div.heading
      [:h3 "Car Details"]]
     (when car-selected?
       (str/join " - " (remove nil? [year make model vin])))
     [make-model-selector form]
     [text-fields form]]))

(defn choose-existing
  "NOTE: When editing this as admin, the selectable cars
  does not reflect the original posters' cars, so no default is selected."
  [{:keys [get-val set-val radio *data] :as form}]
  (let [*user-cars (subscribe [:user-cars])
        *selected (r/atom nil)
        *edit (r/atom false)]
    (fn []
      (if (seq @*user-cars)
        [:div
         [radio
          (mapv
           (fn [{id :db/id
                 :car/keys [make model year vin] :as car}]
             {:title (str/join " - " (remove nil? [year make model vin]))
              :on-select #(do
                            (set-val [:car] dissoc :car/make :car/model :car/year)
                            (reset! *edit false))

              :value id})
           @*user-cars)
          [:car :db/id]]
         [(fn []
            (when (get-val [:car :db/id])
              [:div.input-wrap
               [:button.btn.primary
                {:type "button"
                 :on-click #(reset! *edit true)}
                "Edit Selected Car"]]))]
         " "
         [(fn []
            (when @*edit
              [:div
               [edit-car (assoc form
                                :default-vals
                                (first (filter #(= (:db/id %) (get-val [:car :db/id])) @*user-cars)))]]))]]
        [:div "No cars added yet"]))))

(defn car-form [{:keys [form] :as argz}]
  (let [{:keys [input set-val get-val *data]} form
        *user-cars (subscribe [:user-cars])
        *mode (r/atom (if (seq @*user-cars)
                        :choose-car
                        :add-new))]
    (fn []
      (let [car (get-val [:car])
            {:car/keys [year make model vin]} car]
        [:div.car-form.form-section.step-input-variant-1.elevated
         [:div.heading
          [:h3 (tr :forms.car.title)]]
         (into [:div.add-or-choose-car]
               (map (fn [[s kw]]
                      [:div
                       {:on-click #(reset! *mode kw)
                        :class (when (= @*mode kw) "active")}
                       s])
                    [[(tr :forms.car.choose) :choose-car]
                     [(tr :forms.car.new) :add-new]]))
         (condp = @*mode
           :choose-car [choose-existing form]
           :add-new [new-car form])]))))
